import { render, staticRenderFns } from "./RoHHeader.vue?vue&type=template&id=ca54b03c&scoped=true&"
import script from "./RoHHeader.vue?vue&type=script&lang=js&"
export * from "./RoHHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca54b03c",
  null
  
)

export default component.exports